import { motion } from "framer-motion"

import AboutUsHighlightSection from '../../molecules/AboutUsHighlightSection/AboutUsHighlightSection'
import AboutUsStat from '../../molecules/AboutUsStat/AboutUsStat'
import ExpertTeam from '../../molecules/ExpertTeam/ExpertTeam'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Work from '../../molecules/Work/Work'
import GuideUs from '../../molecules/GuideUs/GuideUs'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import Header from '../../organisms/Header/Header'
import AboutUsHeroSection from '../../organisms/AboutUsHeroSection/AboutUsHeroSection'

const AboutUsPage = () => {

  // 🔥 SAME animation as homepage
  const fadeUp = {
    initial: { opacity: 0, y: 80 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, margin: "-100px" },
    transition: { duration: 0.7, ease: 'easeIn' as const }
  };

  return (
    <div className="min-h-screen bg-[#0E0924] text-white">

      {/* Hero (no animation usually) */}
      <AboutUsHeroSection header={<Header />} />

      {/* Sections with smooth scroll */}
      <motion.div {...fadeUp}>
        <AboutUsStat showStats showStoryBlock={false} showFounderBlock={false} />
      </motion.div>

      <motion.div {...fadeUp}>
        <AboutUsHighlightSection
          leftImageSrc="/webp/aboutus1.webp"
          rightImageSrc="/webp/aboutus2.webp"
          leftImageAlt="Team collaboration"
          rightImageAlt="Engineering workspace"
          heading="Building the Future, One Line at a Time"
          paragraphLead="The Coding Studio"
          paragraphRest="was founded on a simple observation: too many organizations in Fintech & Healthcare were being failed by technology partners who did not understand what was at stake."
          paragraphResttwo="We watched projects collapse because vendors treated compliance as a checkbox. We saw automation initiatives fail because teams prioritized speed over substance. We witnessed brilliant product visions die in the gap between what was promised & what was delivered."
        />
      </motion.div>

      <motion.div {...fadeUp}>
        <AboutUsStat showStats={false} showStoryBlock showFounderBlock={false} />
      </motion.div>

      <motion.div {...fadeUp}>
        <Work showComposition showHowWeWork={false} />
      </motion.div>

      <motion.div {...fadeUp}>
        <AboutUsStat showStats={false} showStoryBlock={false} showFounderBlock />
      </motion.div>

      <motion.div {...fadeUp}>
        <Work showComposition={false} showHowWeWork />
      </motion.div>

      <motion.div {...fadeUp}>
        <GuideUs />
      </motion.div>

      <motion.div {...fadeUp}>
        <ExpertTeam />
      </motion.div>

      <motion.div {...fadeUp}>
        <Testimonial className="mx-auto mb-20 max-w-[90%]" />
      </motion.div>

      {/* Message + Questions */}
      <motion.div {...fadeUp}>
      <div className="mb-10 mt-25  px-4 md:px-8 2xl:mx-20 xl:px-12">
      <div className="grid w-full text-center items-center justify-center grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
            <Message />
            <Questions />
          </div>
        </div>
      </motion.div>

      <motion.div {...fadeUp}>
        <Footer />      
      </motion.div>

    </div>
  )
}

export default AboutUsPage